import type { InjectionKey } from 'vue';

export interface PanelTabRegistration {
    // Stable identity for unregister and for the DOM ids that link the tab
    // button to its panel; values/labels may collide in theory.
    id: string;
    value: string | number;
    label: string;
    // Marks this tab as the initial selection when the parent is uncontrolled.
    isDefault: boolean;
}

export interface PanelTabsContext {
    register: (tab: PanelTabRegistration) => void;
    unregister: (id: string) => void;
    isActive: (value: string | number) => boolean;
}

export const PanelTabsKey: InjectionKey<PanelTabsContext> = Symbol('PanelTabs');

// Stable, unique fallback id for <PanelTab>s that omit an explicit `value`.
// Lives at module scope so ids stay unique across all component instances.
let nextTabId = 0;
export const nextPanelTabId = () => `panel-tab-${nextTabId++}`;
